import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { tokens, useBrsCreateStyles } from '../BrsCreateStyles';

export const BulkAddModal = ({ open, onClose, onAdd }) => {
  const classes = useBrsCreateStyles();
  const [textValue, setTextValue] = useState('');

  const handleAdd = () => {
    const iscis = textValue
      .split(/[,\n]/)
      .map((s) => s.trim())
      .filter(Boolean);
    if (iscis.length > 0) {
      onAdd(iscis);
      setTextValue('');
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          background: tokens.bgCard,
          border: `1px solid ${tokens.border}`,
          borderRadius: 4,
          color: tokens.text,
          minWidth: 480,
        },
      }}
    >
      <DialogTitle style={{ color: tokens.text }}>Bulk Add ISCIs</DialogTitle>
      <DialogContent>
        <p style={{ fontSize: 13, color: tokens.textDim, marginBottom: 12 }}>
          Enter multiple ISCIs separated by commas or new lines. Each ISCI will create a new broadcast request entry.
        </p>
        <textarea
          className={classes.formInput}
          style={{ minHeight: 120, resize: 'vertical' }}
          placeholder="445HSK0293H&#10;445MY36DR2H&#10;445MY38DR2H"
          value={textValue}
          onChange={(e) => setTextValue(e.target.value)}
        />
      </DialogContent>
      <DialogActions style={{ padding: '8px 24px 16px' }}>
        <button className={`${classes.btn} ${classes.btnGhost}`} onClick={onClose} type="button">
          Cancel
        </button>
        <button
          className={`${classes.btn} ${classes.btnPrimary}`}
          onClick={handleAdd}
          disabled={!textValue.trim()}
          type="button"
        >
          Add ISCIs
        </button>
      </DialogActions>
    </Dialog>
  );
};
